module.exports = __webpack_public_path__ + "static/img/bg_coupon_five_grey_used.fc24275.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg_coupon_five_grey_used.png
// module id = yVzx
// module chunks = 0